import { http } from "./http";

// 获取律所（合同签订单位）列表
export async function fetchPublicLawFirmsApi(params = {}) {
  return http.get(`/public/law-firms`, { params });
}

// 获取团队列表
export async function fetchPublicTeamsApi() {
  return http.get(`/public/teams`);
}

// 获取角色列表
export async function fetchPublicRolesApi() {
  return http.get(`/public/roles`);
}

// 获取用户列表
export async function fetchPublicUsersApi(params = {}) {
  return http.get(`/public/users`, { params });
}

// 获取审级列表（公共接口）
export async function fetchPublicReviewLevelsApi(params = {}) {
  return http.get(`/public/review-levels`, { params });
}